export class ProductOrderData {
	availableLaterDate: number;
	priceListNo: string;
	priceListLineNo: string;
	type: number;
	quantity: number;
	buyAll: boolean;
}
